import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Box } from '@chatterbug/aaron'

const AchievementsSkeleton = ({
  headerSection,
  progressSection,
  flashcardsSection,
  allTimeStatsSection,
  liveLessonSection,
  mediaSection,
  writingSection,
  conceptsSection,
  certSection,
  leaderboardSection,
}) => {
  return (
    <Grid gridGap="3x" columns={2}>
      <Box as="h1" variant="text.h3">
        {headerSection}
      </Box>
      <Box sx={{ gridColumn: '1 / span 2' }}>{progressSection}</Box>
      <Box sx={{ gridColumn: '1 / span 2' }}>{allTimeStatsSection}</Box>
      {leaderboardSection && (
        <Box gridColumn={{ _: '1 / span 2', tablet: '1 / span 1' }}>
          {leaderboardSection}
        </Box>
      )}
      {leaderboardSection && (
        <Box gridColumn={{ _: '1 / span 2', tablet: '2 / span 1' }}>
          {certSection}
        </Box>
      )}
      <Box sx={{ gridColumn: '1 / span 2' }}>{liveLessonSection}</Box>
      <Box gridColumn={{ _: '1 / span 2', tablet: '1 / span 1' }}>
        {mediaSection}
      </Box>
      <Box gridColumn={{ _: '1 / span 2', tablet: '2 / span 1' }}>
        {writingSection}
      </Box>
      <Box sx={{ gridColumn: '1 / span 2' }}>{flashcardsSection}</Box>
      <Box gridColumn={{ _: '1 / span 2', tablet: '1 / span 1' }}>
        {conceptsSection}
      </Box>
      {!leaderboardSection && (
        <Box gridColumn={{ _: '1 / span 2', tablet: '2 / span 1' }}>
          {certSection}
        </Box>
      )}
    </Grid>
  )
}

AchievementsSkeleton.propTypes = {
  headerSection: PropTypes.any,
  progressSection: PropTypes.any,
  flashcardsSection: PropTypes.any,
  allTimeStatsSection: PropTypes.any,
  liveLessonSection: PropTypes.any,
  mediaSection: PropTypes.any,
  writingSection: PropTypes.any,
  conceptsSection: PropTypes.any,
  certSection: PropTypes.any,
  leaderboardSection: PropTypes.any,
}

export default AchievementsSkeleton
